let env = process.env.REACT_APP_ENV ? process.env.REACT_APP_ENV : process.env.NODE_ENV;

if (!env) {
	console.error('ENV: ', env);
	env = 'development';
}

let gameUrl = 'localhost:3000';
let apiURL = 'http://localhost:8080/api/';


if (env === 'test' || env === 'demo') {
	gameUrl = 'cgl-absalon-test.web.app';
	apiURL = 'https://cgl-absalon-test.web.app/api/';
	if (env === 'demo') {
		gameUrl = 'cgl-absalon-demo.web.app';
		apiURL = 'https://cgl-absalon-demo.web.app/api/';
	}
}

if (env === 'production') {
	gameUrl = 'cgl-absalon-production.web.app';
	apiURL = 'https://cgl-absalon-production.web.app/api/';
}

const appConfig = {
	env: env,
	name: 'absalon',
	gameUrl: gameUrl,
	apiURL: apiURL,
	cookieConsentName: 'cgl_absalon_cookies',
	cookiePlayerData: 'cgl_absalon_playerData',
	recipeLoadTimeMin: 3,
	recipeLoadTimeMax: 7,
};

export default appConfig;